<app-modal-pesquisa-lista
  [aberta]="aberta"
  titulo="Pesquisar funcionario"
  [termo]="termo"
  nomeCampo="buscaFuncionarioExportacaoModal"
  placeholder="Digite nome, matricula ou CPF"
  mensagemVazia="Digite ao menos 3 caracteres para pesquisar."
  [itens]="funcionarios"
  [rotuloItem]="rotuloFuncionario"
  [detalheItem]="detalheComCpf"
  (termoChange)="termoChange.emit($event)"
  (selecionar)="selecionarFuncionario($event)"
  (limpar)="limpar.emit()"
  (fechar)="fechar.emit()">
</app-modal-pesquisa-lista>
